
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { 
  LogOut, 
  Globe, 
  Settings, 
  ChevronDown,
  Home,
  Store,
  Users,
  FileText,
  MessageSquare
} from 'lucide-react';

interface SuperAdminControlsProps {
  onLogout: () => void;
}

const SuperAdminControls = ({ onLogout }: SuperAdminControlsProps) => {
  return (
    <div className="flex items-center gap-2 sm:gap-4">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="flex items-center gap-2 text-sm sm:text-base px-2 sm:px-4">
            <Settings className="h-4 w-4 flex-shrink-0" />
            <span className="hidden sm:inline">أدوات الإدارة</span>
            <span className="sm:hidden">الإدارة</span>
            <ChevronDown className="h-4 w-4 flex-shrink-0" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48 sm:w-52">
          <DropdownMenuItem asChild>
            <Link to="/oil-request-admin" className="flex items-center gap-2">
              <MessageSquare className="h-4 w-4" />
              إدارة طلبات الزيوت
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link to="/" className="flex items-center gap-2">
              <Home className="h-4 w-4" />
              عرض الصفحة الرئيسية
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/shops" className="flex items-center gap-2">
              <Store className="h-4 w-4" />
              عرض الورش
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/products" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              عرض المنتجات
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/product-import" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              استيراد المنتجات
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <a 
              href="/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              <Globe className="h-4 w-4" />
              فتح الموقع (تبويب جديد)
            </a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Button
        onClick={onLogout}
        variant="outline"
        className="flex items-center gap-2 text-red-600 hover:bg-red-50 hover:border-red-300 text-sm sm:text-base px-2 sm:px-4"
      >
        <LogOut className="h-4 w-4 flex-shrink-0" />
        <span className="hidden sm:inline">تسجيل الخروج</span>
        <span className="sm:hidden">خروج</span>
      </Button>
    </div>
  );
};

export default SuperAdminControls;
